var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-config-container" },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addAct } },
                    [_vm._v("添加任务设置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rewardType",
                  label: "奖励类型",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.rewardType == 1
                          ? _c("div", [_vm._v("积分")])
                          : scope.row.rewardType == 2
                          ? _c("div", [_vm._v("优惠券")])
                          : _c("div", [_vm._v("其他")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "状态",
                  prop: "",
                  align: "center",
                  width: "300",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.changeStatus(
                                scope.row.id,
                                scope.row.status
                              )
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  fixed: "right",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editForm(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "种草官任务设置",
            visible: _vm.dialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: function ($event) {
              _vm.dialogVisible = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "任务条件" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: !!_vm.form.id },
                      on: { change: _vm.changeTaskCategory },
                      model: {
                        value: _vm.form.taskCategory,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskCategory", $$v)
                        },
                        expression: "form.taskCategory",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 3 } }, [_vm._v("叠加")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("满足任意条件"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("无视类型"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.taskCategory == 1 || _vm.form.taskCategory == 3
                ? _c(
                    "el-form-item",
                    { attrs: { label: "任务类型" } },
                    _vm._l(_vm.form.ruleList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-bottom": "10px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "250px" },
                              attrs: {
                                disabled: !!_vm.form.id,
                                placeholder: "请选择任务类型",
                              },
                              model: {
                                value: item.taskType,
                                callback: function ($$v) {
                                  _vm.$set(item, "taskType", $$v)
                                },
                                expression: "item.taskType",
                              },
                            },
                            _vm._l(_vm.typeOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.taskTypeName,
                                  value: String(item.id),
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: { width: "150px", margin: "10px" },
                            attrs: { disabled: !!_vm.form.id },
                            model: {
                              value: item.monthlyTarget,
                              callback: function ($$v) {
                                _vm.$set(item, "monthlyTarget", $$v)
                              },
                              expression: "item.monthlyTarget",
                            },
                          }),
                          _vm._v("篇/月\n\n                    "),
                          _c("div", [
                            !_vm.form.id
                              ? _c("i", {
                                  staticClass: "el-icon-circle-plus-outline",
                                  staticStyle: {
                                    color: "#589eff",
                                    "font-size": "24px",
                                    margin: "0 10px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAdd(1)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.ruleList.length > 1 && !_vm.form.id
                              ? _c("i", {
                                  staticClass: "el-icon-remove-outline",
                                  staticStyle: {
                                    color: "#589eff",
                                    "font-size": "24px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleReduce(index, 1)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.taskCategory == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "总数量" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "10px" },
                        attrs: { disabled: !!_vm.form.id },
                        model: {
                          value: _vm.totalNum,
                          callback: function ($$v) {
                            _vm.totalNum = $$v
                          },
                          expression: "totalNum",
                        },
                      }),
                      _vm._v("篇\n            "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "奖励类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: !!_vm.form.id },
                      model: {
                        value: _vm.form.rewardType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rewardType", $$v)
                        },
                        expression: "form.rewardType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("积分")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("优惠券"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "奖励内容" } },
                [
                  _vm.form.rewardType == 1
                    ? _c(
                        "div",
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { disabled: !!_vm.form.id },
                            model: {
                              value: _vm.form.rewardValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "rewardValue", $$v)
                              },
                              expression: "form.rewardValue",
                            },
                          }),
                          _vm._v("积分\n                "),
                        ],
                        1
                      )
                    : _vm._l(_vm.form.couponList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "margin-bottom": "10px",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  width: "300px",
                                  "margin-right": "10px",
                                },
                                attrs: {
                                  disabled: !!_vm.form.id,
                                  placeholder: "请输入优惠券，支持模糊查询",
                                  filterable: "",
                                  remote: "",
                                  "reserve-keyword": "",
                                  "remote-method": _vm.fetchCoupons1,
                                  loading: _vm.couponLoading,
                                },
                                model: {
                                  value: item.couponId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "couponId", $$v)
                                  },
                                  expression: "item.couponId",
                                },
                              },
                              _vm._l(_vm.couponOptions1, function (coupon) {
                                return _c("el-option", {
                                  key: coupon.thirdCouponId,
                                  attrs: {
                                    label: coupon.typeName,
                                    value: coupon.thirdCouponId,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm._v("\n\n                    数量："),
                            _c("el-input", {
                              staticStyle: { width: "50px" },
                              model: {
                                value: item.quantity,
                                callback: function ($$v) {
                                  _vm.$set(item, "quantity", $$v)
                                },
                                expression: "item.quantity",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", [
                              !_vm.form.id
                                ? _c("i", {
                                    staticClass: "el-icon-circle-plus-outline",
                                    staticStyle: {
                                      color: "#589eff",
                                      "font-size": "24px",
                                      margin: "0 10px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAdd(2)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.couponList.length > 1 && !_vm.form.id
                                ? _c("i", {
                                    staticClass: "el-icon-remove-outline",
                                    staticStyle: {
                                      color: "#589eff",
                                      "font-size": "24px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleReduce(index, 2)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ],
                          1
                        )
                      }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "月度基础帖限制数量",
                    prop: "monthlyBaseLimit",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { disabled: !!_vm.form.id },
                    model: {
                      value: _vm.form.monthlyBaseLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "monthlyBaseLimit", $$v)
                      },
                      expression: "form.monthlyBaseLimit",
                    },
                  }),
                  _vm._v("篇\n            "),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }